import React from "react";
import IncidentDashboard from "./components/IncidentDashboard";
import { INCIDENTS_MODULE } from "../../constants/modules";
import { fetchIncidentsByDepartment } from "./services/service";
import { IncidentDepartmentEnum } from "../../constants/incidents";

const FireSafetyIncident: React.FC = () => (
  <IncidentDashboard
    department={IncidentDepartmentEnum.FireSafety}
    pageTitle="Incident Management"
    moduleKey={INCIDENTS_MODULE}
    fetchService={fetchIncidentsByDepartment}
  />
);

export default FireSafetyIncident;
